import { axiosInstance } from './instance';
import { parseCartDiscountTierResponse } from '../constants/cartDiscountTierConfig';

export const getCartDiscountTierService = (storeId) => {
    return axiosInstance.get(`/stores/${storeId}/cart-discount-tier`);
};

export const upsertCartDiscountTierService = (storeId, data) => {
    return axiosInstance.put(`/stores/${storeId}/cart-discount-tier`, data);
};

export const deleteCartDiscountTierService = (storeId) => {
    return axiosInstance.delete(`/stores/${storeId}/cart-discount-tier`);
};

export const parseCartDiscountTierFromResponse = (data) => parseCartDiscountTierResponse(data);
